import { Typography } from 'antd';
import { typeScale } from './tokens';

/**
 * Small section heading used by the super-admin resource pages (detail-view
 * tabs, form sections). Rendered as an AntD Title level-5 with the top margin
 * zeroed so it sits flush at the top of a card/section.
 *
 * NB: the customer SPA has its own distinct `SectionHeader` (an uppercase
 * eyebrow label) in src/components; that one is unrelated and stays put.
 */
export function SectionHeader({
  children,
  style,
}: {
  children: React.ReactNode;
  style?: React.CSSProperties;
}) {
  return (
    <Typography.Title level={5} style={{ marginTop: 0, fontSize: typeScale.h5, ...style }}>
      {children}
    </Typography.Title>
  );
}
